<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="420px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="disabled"
        :techDocCode="techDocCode"
        :techCode="techCode"
        :orderCode="orderCode"
        @close="$emit('close')"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!disabled"
          @click="$refs.editForm.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: {
    EditForm,
  },
  props: {
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    techDocCode: String,
    techCode: String,
  },
  methods: {},
}
</script>
